module.exports = __webpack_public_path__ + "img/ai_greet.3114dfc8.png";